import type { SVGProps } from 'react';
export const Visibility = (props: SVGProps<SVGSVGElement>) => (
  <svg width="1rem" height="1rem" fill="currentColor" viewBox="0 0 20 20" {...props}>
    <path
      fillRule="evenodd"
      d="M4.66 7.5A7.4 7.4 0 0 1 10 5.24a7.4 7.4 0 0 1 5.34 2.24 9 9 0 0 1 1.6 2.23v.02l-.58.26.58.26v.02l-.1.2q-.1.19-.3.5c-.25.42-.65.97-1.2 1.53A7.4 7.4 0 0 1 10 14.75a7.4 7.4 0 0 1-5.34-2.24 9 9 0 0 1-1.6-2.23v-.02l.58-.26-.58-.26v-.02l.1-.2q.1-.19.3-.5c.25-.42.65-.97 1.2-1.53M3.64 10l-.59-.26a.6.6 0 0 0 0 .52zm.71 0q.07.13.18.3c.22.36.56.83 1.03 1.3A6 6 0 0 0 10 13.47a6 6 0 0 0 4.44-1.87 8 8 0 0 0 1.2-1.6l-.17-.3a8 8 0 0 0-1.03-1.3A6 6 0 0 0 10 6.53 6 6 0 0 0 5.56 8.4a8 8 0 0 0-1.2 1.6m12.01 0 .59.26a.6.6 0 0 0 0-.52zM10 8.36A1.64 1.64 0 1 0 11.64 10c0-.9-.74-1.64-1.64-1.64M7.1 10a2.92 2.92 0 1 1 2.9 2.92c-1.6 0-2.9-1.3-2.9-2.92m-2.88-.26"
      clipRule="evenodd"
    />
  </svg>
);
